export const validation = {
  privacyPolicy: 'Privacy policy url is required',
  terms: 'Terms of use url is required',
  aboutUs: 'About us url is required',
  validUrl: 'Please enter valid url.',
  paymentFailed: 'Payment failed ! Please check billing Report.',
};
